import { computed, readonly, ref, watchEffect } from "vue";
import { BenPlayerApi } from "@/api-connector/ben-be-player/methods/ben-player-api";
import useUserAccount, { clientId } from "@/account/use-user-account";
import { useUserConsents } from "@/account/composables/use-user-consents";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { PlayerObtainableBonusDto } from "@/api-connector/ben-be-player/models/ben-player-models";

const obtainableBonusData = ref<PlayerObtainableBonusDto>(null);

const bonusBannerLink = computed(() =>
    obtainableBonusData.value ? `/sazka-klub/historie-bonusu?id=${obtainableBonusData.value.id}` : null
);
const bonusBannerTextShort = computed(() => {
    if (!obtainableBonusData.value) return null;

    return `<strong>Získejte bonus ${obtainableBonusData.value.winAmount}&nbsp;Kč</strong>`;
});

const bonusBannerTextLong = computed(() => {
    if (!obtainableBonusData.value) return null;

    const validToString = DateTimeUtils.formatDate(new Date(obtainableBonusData.value.validTo));

    let conditionTypeString = "";
    switch (obtainableBonusData.value.conditionType) {
        case "Lottery":
            conditionTypeString = "loterii";
            break;
        case "Scratchcard":
            conditionTypeString = "stírací los";
            break;
    }

    return `Kupte si ${conditionTypeString}
        <strong>${obtainableBonusData.value.conditionGame} za ${obtainableBonusData.value.conditionAmount}&nbsp;Kč do ${validToString}</strong> a
        získejte <strong>bonus ${obtainableBonusData.value.winAmount}&nbsp;Kč</strong>.`;
});

const initData = async () => {
    const { waitForUserAccount } = useUserAccount();
    await waitForUserAccount();

    const { userConsents } = useUserConsents();

    watchEffect(async () => {
        if (clientId.value && userConsents.personalisation) {
            obtainableBonusData.value = await BenPlayerApi.getObtainableBonusBanner(clientId.value);
        } else {
            obtainableBonusData.value = null;
        }
    });
};

let isInited = false;
export function useObtainableBonus(withoutInit = false) {
    if (!isInited && !withoutInit) {
        isInited = true;
        initData();
    }
    return {
        obtainableBonusData: readonly(obtainableBonusData),
        bonusBannerLink,
        bonusBannerTextShort,
        bonusBannerTextLong,
    };
}
